import { apiFunction } from '../../../apiCalls/functions/';

export const handleChangePassword = async (data) => {
  return await apiFunction(`auth/change-password`, 'post', data, true, false);
};
